import React from 'react';
import { Heading } from '@innovationnorway/cl-react';

const InfoBox = ({ heading, children }: { heading: string; children: React.ReactNode }) => {
  return (
    <section className="opportunity-overview--box">
      <Heading className="font-size--ds-5" level={3}>
        {heading}
      </Heading>
      <div className="margin-top--ds-4">{children}</div>
    </section>
  );
};

export default InfoBox;
